function createDefaultEmptyComponent(param) {
    var createElement = param.createElement, Fragment = param.Fragment;
    return function DefaultEmpty() {
        return /*#__PURE__*/ createElement(Fragment, null, "No results");
    };
}

export { createDefaultEmptyComponent };
